import Vue from 'vue';
import { mapActions } from 'vuex';
import AuthHeader from '../components/AuthHeader.vue';
import RegisterConfirm from '../components/RegisterConfirm.vue';
import Login from './Login.vue';
import Register from './Register.vue';
import { AuthMode } from '../auth-mode.enum';
import NewPassword from './NewPassword.vue';
import NewPasswordConfirm from '../components/NewPasswordConfirm.vue';
import PasswordChanged from '../components/PasswordChanged.vue';
export default Vue.extend({
    components: {
        Login,
        Register,
        AuthHeader,
        RegisterConfirm,
        NewPassword,
        NewPasswordConfirm,
        PasswordChanged,
    },
    props: {
        noClose: {
            type: Boolean,
            default: false,
        },
        backToShopping: {
            type: Boolean,
            default: false,
        },
        redirect: {
            type: String,
            default: '/account',
        },
        ifAddToWishlist: {
            type: Object,
            default: null,
        },
        name: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            currentMode: AuthMode.LoginForm,
            isLoading: false,
            email: '',
            Mode: AuthMode,
        };
    },
    created() {
        // @TODO uncomment after refreshToken stop being mock
        //this.refreshToken();
        //display password change confirmation
        if (this.$route.query.show == 'password-changed') {
            this.switchMode(this.Mode.PasswordChanged);
        }
    },
    computed: {
        title() {
            return this.Mode.LoginForm === this.currentMode ? 'Log in' : 'Sign up';
        },
    },
    methods: {
        ...mapActions('authModule', ['refreshToken']),
        switchMode(mode) {
            this.currentMode = mode;
        },
        hideModal() {
            this.$refs['authModal'].hide();
        },
        delaySwitchMode() {
            setTimeout(() => this.switchMode(this.Mode.LoginForm), 1000);
        },
        redirectSocial(driver) {
            // @todo pass url from ENV
            window.location.href =
                process.env.MIX_MY_ACCOUNT_URL +
                    '/login/' +
                    driver +
                    '?returnToken=1&application=get-it&redirect=' +
                    encodeURIComponent(window.location.href);
        },
    },
});
